<template>
  <el-dialog
    title="修改退货地址"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form
      :model="editShopReturnAddressInfo"
      :rules="rules"
      ref="editForm"
      label-width="120px"
    >
      <el-form-item label="收货人名称" prop="name">
        <el-input
          v-model="editShopReturnAddressInfo.name"
          placeholder="必填，请填写收货人名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="link">
        <el-input
          v-model="editShopReturnAddressInfo.link"
          placeholder="必填，请填写联系电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="seq">
        <el-input
          v-model="editShopReturnAddressInfo.seq"
          placeholder="必填，请填写排序"
        ></el-input>
      </el-form-item>
      <el-form-item label="详细地址" prop="address">
        <el-input
          type="textarea"
          v-model="editShopReturnAddressInfo.address"
          placeholder="选填，请填写详细地址"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="editShopReturnAddress">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { updateShopReturnAddress } from '@/api/goods/shopReturnAddressApi'

export default {
  name: 'EditShopReturnAddress',
  data() {
    return {
      dialogVisible: false,
      editShopReturnAddressInfo: {
        addressId: '',
        name: '',
        link: '',
        address: '',
        seq: '',
        shopId: ''
      },
      rules: {
        name: [
          { required: true, message: '收货人名称不能为空', trigger: 'blur' },
          { max: 64, message: '收货人名称太长', trigger: 'blur' }
        ],
        link: [
          { required: true, message: '联系电话不能为空', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '联系电话格式错误', trigger: 'blur' }
        ],
        seq: [
          { required: true, message: '排序不能为空', trigger: 'blur' },
          { pattern: /^\d+$/, message: '排序不是有效数字', trigger: 'blur' }
        ],
        address: [
          { max: 512, message: '详细地址太长', trigger: 'blur' }
        ],
        addressId: [
          { required: true, message: '地址ID不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.editShopReturnAddressInfo = {
        ...row,
        shopId: getShopId()
      }
    },
    handleClose() {
      this.$refs.editForm.resetFields()
      },
    async editShopReturnAddress() {
      this.$refs.editForm.validate(async valid => {
        if (!valid) return
        
        try {
          await updateShopReturnAddress(this.editShopReturnAddressInfo)
          this.$message.success('修改成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          console.error('修改退货地址失败:', error)
        }
      })
    }
  }
}
</script>